
      import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaFacebookF, FaInstagram, FaYoutube, FaHeadphones } from "react-icons/fa";
import "../Styles/TopDeals.css"; // Ensure this has relevant custom styles if needed

const ContactUs = () => {
  return (
    <Container fluid className="py-5 contact-us-section bg-light">
      <Row className="text-center mb-4">
        <Col>
          <h2 className="display-6 fw-bold">We'd love to hear from you</h2>
          <h4 className="text-muted">Stay Connected</h4>
          <hr className="w-25 mx-auto my-3" />
          <p className="lead">
            Send in your questions below, or email us at{" "}
            <a href="mailto:support@matihaat.com" className="text-decoration-underline">support@matihaat.com</a>. <br />
            We will get back to you within 24 hours.
          </p>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="mb-4">
          <iframe
            title="MatiHaat Location"
            src="https://maps.google.com/maps?q=Gurgaon%20Faridabad%20Road%2C%20Opp.%20Paras%20Trade%20Centre%2C%20Gwalpahari%2C%20Gurgaon%20122002&t=m&z=13&output=embed"
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </Col>

        <Col md={6}>
          <h4 className="mb-3">Reach us through</h4>
          <ul className="list-unstyled">
            <li className="mb-2">
              <strong>📍 Address:</strong> MatiHaat, 10/3 Wisteria Club Road, Opp. HDFC Bank, Baliawas, Gurgaon 122002
            </li>
            <li className="mb-2">
              <strong>📞 Phone:</strong> +91 9654870373
            </li>
            <li className="mb-2">
              <strong>📧 Email:</strong> support@matihaat.com
            </li>
          </ul>
        </Col>
      </Row>

      <Row className="mt-5 justify-content-center">
        <Col xs="auto">
          <a href="https://facebook.com" className="text-dark fs-4 mx-3"><FaFacebookF /></a>
          <a href="https://instagram.com" className="text-dark fs-4 mx-3"><FaInstagram /></a>
          <a href="https://youtube.com" className="text-dark fs-4 mx-3"><FaYoutube /></a>
          <a href="tel:+919654870373" className="text-dark fs-4 mx-3"><FaHeadphones /></a>
        </Col>
      </Row>
      <footer style={{ backgroundColor: "#f9f9f9", color: "#2b2b2b", padding: "40px 0" }}>
      <Container>
        <Row className="text-center text-md-start">
          {/* Left Column */}
          <Col md={4} className="mb-4 mb-md-0">
            <img
              src="https://matifoods.in/wp-content/uploads/2022/04/Mati-Haat-Web-Logo-2.png"
              alt="Mati Haat"
              style={{ width: "130px", marginBottom: "20px" }}
            />
            <div className="d-flex align-items-center justify-content-center justify-content-md-start">
              <FaHeadphones style={{ color: "#8BC34A", fontSize: "30px", marginRight: "10px" }} />
              <div>
                <p className="mb-0">Got Questions? Call us 24/7!</p>
                <strong>+91 9654870373</strong>
              </div>
            </div>
            <div className="mt-4 d-flex justify-content-center justify-content-md-start gap-3">
              <a href="https://www.facebook.com/profile.php?id=61550736893804" style={{ color: "#000" }} className=" fs-5" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="https://www.instagram.com/matihaat/" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.youtube.com/@FarmingwithMatihaat" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            </div>
          </Col>

          {/* Middle Column - Quick Links */}
          <Col md={4} className="mb-4 mb-md-0">
            <h5 style={{ color: "#7BA127" }}>Quick Links</h5>
            <ul className="list-unstyled">
              <ul className="list-unstyled">
                <li><a href="/about-us" style={{ color: "#000" }} className="text-decoration-none">About Us</a></li>
                <li><a href="/contact-us" style={{ color: "#000" }} className="text-decoration-none">Reach Us</a></li>
               
                
                
                <li><a href="/track-order" style={{ color: "#000" }} className="text-decoration-none">Track your Order</a></li>
              </ul>
            </ul>
          </Col>

          {/* Right Column - Customer Care */}
          <Col md={4}>
            <h5 style={{ color: "#7BA127" }}>Customer Care</h5>
            <ul className="list-unstyled">
              <li><a href="/privacy-policy" style={{ color: "#000" }} className="text-decoration-none">Privacy Policy</a></li>
              <li><a href="/shipping-policy" style={{ color: "#000" }} className="text-decoration-none">Shipping Policy</a></li>
              <li><a href="/refund-policy" style={{ color: "#000" }} className="text-decoration-none">Refund and Returns Policy</a></li>
              <li><a href="/payment-methods" style={{ color: "#000" }} className="text-decoration-none">Payment Methods</a></li>
              <li><a href="/terms-and-conditions" style={{ color: "#000" }} className="text-decoration-none">Terms and Conditions</a></li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
    </Container>
    
  );
};

export default ContactUs;

 